<template>
  <div class="task-container">
    <img
      class="toast-bg"
      src="https://btw-common-data.betterwestar.com/btw-admin/resource/b30bf287f0ecd9587180b3370a972c36_wh=1125_870.png"
      alt=""
    />
    <img
      class="title-image"
      src="https://btw-common-data.betterwestar.com/btw-admin/resource/820bda54a54d4531c9342eae4ed52396_wh=576_189.png"
      alt=""
    />
    <div class="close" @click="bindClose"
      ><span class="iconfont icon-cha"></span
    ></div>
    <div class="task-flex">
      <div class="task-scroll">
        <div class="task-list">
          <div class="task-item" v-for="(item, index) in taskData" :key="index">
            <div class="task-title">{{ item.plan_type_name }}</div>
            <div class="task-li">
              <div
                class="task-li-item"
                v-for="(item1, index1) in item.list"
                :key="index1"
              >
                <img class="item-icon" :src="item1.icon" alt="" />
                <div class="item-center">
                  <div class="item-name" v-html="item1.name"></div>
                  <div class="item-desc"
                    ><span class="item-desc-text">{{ item1.notice }}</span
                    ><img
                      class="flower-image"
                      src="https://btw-common-data.betterwestar.com/btw-admin/resource/71ba3142596f4cf6b18e50e08fa3ca17_wh=66_66.png"
                      alt=""
                    /><span class="flower-num">+1</span></div
                  >
                </div>
                <div
                  class="item-btn"
                  :class="{
                    'item-btn-confirm': item1.plan_state,
                    'item-btn-disabled': item1.complete_type == 4
                  }"
                  @click="bindClickItem(item1)"
                  >{{ item1.plan_state ? '已完成' : item1.button_content }}</div
                >
              </div>
            </div>
          </div>
        </div>
        <div class="space"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      taskData: []
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.getTaskList()
      }
    }
  },
  created() {
    this.getTaskList()
  },
  methods: {
    async getTaskList() {
      let res = await this.$http
        .getApp('api/v1/AnnualCoach/getActivityPlanList', { activity_id: 1 })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.taskData = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindClose() {
      this.$emit('close')
    },
    bindSendFlower() {},
    async bindClickItem(item) {
      if (item.plan_state) {
        return
      }
      if (item.complete_type == 1) {
        item.plan_state = 1
      }
      if (item.jump_url) {
        let version = await this.$betterwe.getAppVersion().catch(() => {})
        if (version < 252) {
          this.$toast('请下载最新版App')
          return
        }
        this.$betterwe.jumpRoute(item.jump_url)
        this.bindClose()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.task-container {
  position: relative;
  z-index: 1;
  height: 57vh;
  box-sizing: border-box;
  background: linear-gradient(178deg, #ffc0dc 0%, #fff3f8 100%);
  border-radius: 8px 8px 0px 0px;
  padding: 95px 12px 0px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .toast-bg {
    z-index: -1;
    width: 100%;
    left: 0;
    top: -26px;
    position: absolute;
  }
  .title-image {
    z-index: -1;
    width: 192px;
    left: 20px;
    top: 20px;
    position: absolute;
  }
  .tips {
    margin-top: 53px;
    margin-bottom: 9px;
    font-weight: bold;
    font-size: 12px;
    color: rgba(48, 48, 56, 0.78);
    line-height: 18px;
  }
  .task-scroll {
    height: 100%;
    border-radius: 8px 8px 0px 0px;
    overflow-y: scroll;
  }
  .task-flex {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
  .task-list {
    .task-item {
      background-color: #fff;
      border-radius: 8px;
      padding: 14px 12px 20px;
      margin-bottom: 10px;
      .task-title {
        font-weight: bold;
        font-size: 14px;
        color: rgba(5, 11, 39, 0.8);
        line-height: 20px;
        margin-bottom: 14px;
      }
      .task-li {
        .task-li-item {
          display: flex;
          align-items: center;
          padding-bottom: 20px;
          margin-bottom: 19px;
          border-bottom: 0.5px solid rgba(5, 11, 39, 0.1);
          .item-icon {
            width: 44px;
            height: 44px;
            object-fit: contain;
            margin-right: 8px;
          }
          .item-center {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            .item-name {
              font-weight: bold;
              font-size: 14px;
              color: #050b27;
              line-height: 18px;
              margin-bottom: 6px;
            }
            .item-desc {
              font-size: 12px;
              color: rgba(5, 11, 39, 0.5);
              display: flex;
              align-items: center;
              .item-desc-text {
              }
              .flower-image {
                margin-left: 3px;
                display: inline-block;
                width: 13px;
                height: 13px;
                object-fit: contain;
              }
              .flower-num {
                font-family: DIN;
                font-weight: bold;
                font-size: 17px;
                line-height: 17px;
                color: #ff2270;
                margin-bottom: 3px;
              }
            }
          }
          .item-btn {
            width: 68px;
            height: 28px;
            background-color: #ff2270;
            color: #fff;
            border-radius: 19px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            font-size: 12px;
            color: #ffffff;
          }
          .item-btn-disabled {
            color: #ff2270;
            background-color: rgba(255, 34, 112, 0.1);
          }
          .item-btn-confirm {
            background-color: #f7f7f7;
            color: rgba(5, 11, 39, 0.3);
          }
        }
        .task-li-item:last-child {
          padding-bottom: 0;
          margin-bottom: 0px;
          border-bottom: none;
        }
      }
    }
    .task-item:last-child {
      margin-bottom: 0;
    }
  }
  .space {
    height: 30px;
  }
  .close {
    position: absolute;
    right: 15px;
    top: 15px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      font-weight: bold;
      font-size: 20px;
      color: rgba(48, 48, 56, 1);
    }
  }
}
</style>
